export const setButtonStyle = (buttonStyle) => ({
    type: 'SET_BUTTONSTYLE',
    buttonStyle
});